import { Static, Type } from '@sinclair/typebox';
import { ProviderSchema } from '../../common/provider.schema';
import { StringEnum } from '../../utils/typebox';

export const UserPresenceStatusSchema = StringEnum(['online', 'offline', 'unknown'], {
  description: `Whether the user is currently connected to the provider.
    - \`online\` if the user is connected right now.
    - \`offline\` if the user is not connected. \`last_online_at\` is set when the provider exposes the exact date.
    - \`unknown\` if the provider reports no presence for this user, which usually means the user hides it.`,
});

export type UserPresenceStatus = Static<typeof UserPresenceStatusSchema>;

export const userPresenceBaseSchema = Type.Object({
  object: Type.Literal('UserPresence'),
  user_id: Type.String({
    description: 'The ID of the User this presence belongs to.',
  }),
  presence: UserPresenceStatusSchema,
  last_online_at: Type.Optional(
    Type.String({
      description:
        'Date and time when the user was last online. Only set when the user is offline and the provider exposes the exact date.',
    }),
  ),
  provider: ProviderSchema,
});

export type ProviderUserPresence = Static<typeof userPresenceBaseSchema>;
